<template>
  <div>
    <NuxtPwaManifest />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <!-- Service Worker Update -->
    <SnackBar v-show="$pwa?.needRefresh">
      Ein Update ist verfügbar
      <template v-slot:action>
        <button @click="$pwa?.updateServiceWorker()" class="btn btn-primary">Aktualisieren</button>
      </template>
    </SnackBar>

    <ErrorDisplay />
  </div>
</template>

<script setup lang="ts">
import printLogo from '~/utils/bahnvorhersageLogo'

useHead({
  titleTemplate: '%s | Bahn-Vorhersage'
})

onMounted(() => {
  printLogo()

  // Disable PWA install as there is a "native" app
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
  })
})
</script>

<style lang="scss">
@import '~/assets/scss/stripedDownBootstrap.scss';
@import '~/assets/fonts/icons/icons.scss';
@import '~/assets/fonts/icons/icons-overrides.scss';
@import '~/assets/scss/journeyDisplay.scss';

.hyphenate {
  hyphens: auto;
}

.pointer-cursor {
  cursor: pointer;
}

.d-contents {
  display: contents;
}

.form-check-label {
  text-shadow: 0px 0px 1px $light;
  transition: color 0.1s;
}

.form-check-label.inactive {
  text-shadow: none;
}
</style>
